import React, { Component, Fragment } from "react";
import "@babel/polyfill";
import { render } from "react-dom";
import "../styles/sass/login.scss";
import $ from "jquery";
import "jquery.cookie";
import _ from "lodash";
import Cookie from "js-cookie";
import { createGetMessage } from "./message";

let { logo, designOptions } = commonui.config;
const site = [
    'hyundai'
]

designOptions === 'dev4' ? $('body').css('background-image', 'none'): $('body').css('background-color', 'none');

if(_.includes(site, logo)){
    import(`../styles/sass/site/${logo}.scss`);
}

// favicon 오류였던 2.3 수정 
require.context(
    `!file-loader?name=[name].[ext]!../styles/images`,
    true,
    /(.ico)\??[\w\d]*$/
);

// 다국어 지원
let locale = Cookie.get("org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE") || (_.includes(['ko', 'ko_kr', 'en'],commonui.defaultLocale.toLowerCase()) ?  commonui.defaultLocale: 'en');

let bindLocaleChangeEvent = function (localeSelectboxSelector, defaultLocale) {
    $(document).ready(function () {
        var locale =
            $.cookie()[
                "org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE"
            ] || defaultLocale;
        $(localeSelectboxSelector)
            .val(_.includes(locale , 'ko') ? 'ko': 'en')
            .change(function (evt) {
                var search = window.location.search;
                var val = $(evt.target).val();
                if (/.*locale=.*/.test(search)) {
                    window.location.search = search.replace(
                        /locale=(\w*)/,
                        "locale=" + val
                    );
                } else if (search) {
                    window.location.search = search + "&locale=" + val;
                } else {
                    window.location.search = search + "locale=" + val;
                }
            });
    });
};

bindLocaleChangeEvent("#locale", _.includes(['ko', 'ko_kr', 'en'],commonui.defaultLocale.toLowerCase()) ?  commonui.defaultLocale: 'en');

export class UserId extends Component {
    render() {
        return <input type="text" placeholder={commonui.messages.userId} {...this.props} />;
    }
}

UserId.defaultProps = {
    name: "username",
};

export class Password extends Component {
    constructor(props) {
        super(props);
        this.onInputChange = this.onInputChange.bind(this);
        this.b64EncodeUnicode = this.b64EncodeUnicode.bind(this);
        this.state = {
            encodedPassword: this.b64EncodeUnicode(""),
        };
    }

    b64EncodeUnicode(value) {
        return btoa(
            encodeURIComponent(value).replace(
                /%([0-9A-F]{2})/g,
                function toSolidBytes(match, p1) {
                    return String.fromCharCode("0x" + p1);
                }
            )
        );
    }

    onInputChange(e) {
        this.setState({
            encodedPassword: this.b64EncodeUnicode(e.target.value),
        });
    }

    render() {
        let props = this.props;
        return (
            <Fragment>
                <input
                    type="password"
                    placeholder={commonui.messages.password}
                    {...props}
                    name={undefined}
                    onChange={this.onInputChange}
                />
                <input
                    type="hidden"
                    name={props.name}
                    value={this.state.encodedPassword}
                />
            </Fragment>
        );
    }
}

Password.defaultProps = {
    name: "password",
};

export class RememberMe extends Component {
    render() {
        return (
            <div className="remember-id-wrapeer"
                onClick={(e)=>{
                    Cookie.set("MDM_ID_SAVED", $('.remember-chk').prop('checked'))
                }}
            >
                <input
                    type="checkbox"
                    className="remember-me remember-chk"
                    id="save-id"
                    name="MDM_ID_SAVED"
                    defaultChecked={
                        !!Cookie.get("MDM_ID_SAVED")
                    }
                />
                <label
                    className="remember-id"
                    htmlFor="save-id"
                >
                </label>
                <span className="remember-id-text">{commonui.messages.savedId}</span>
            </div>
        )
    }
}

RememberMe.defaultProps = {
    name: "remember-me",
};

export class LoginForm extends Component {
    render() {
        let { csrfParameterName, csrfToken } = this.props;
        return (
            <form className="signin" {..._.omit(this.props, "csrfToken", "csrfParameterName")}>
                {csrfToken && csrfParameterName && (
                    <input
                        type="hidden"
                        name={csrfParameterName}
                        value={csrfToken}
                    />
                )}
                {this.props.children}
            </form>
        );
    }
}

export class LoginErrorMessage extends Component {
    render() {
        return <span {...this.props}>{this.props.children}</span>;
    }
}

LoginErrorMessage.defaultProps = {
    children: commonui.errorMessage,
};

LoginForm.defaultProps = {
    action: commonui.loginUrl,
    method: "post",
    csrfToken: commonui.csrfToken,
    csrfParameterName: commonui.csrfParameterName
};

export class MDMLoginForm extends Component {

    // 로그인 화면 다국어 select change 이벤트
    onChangeLang = (e) =>{
        Cookie.set( 'org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE', e.target.value )
        window.location.href = `${WEB_CONTEXT_PATH}?locale=${locale}`;
    }
    render() {
        return (
            designOptions === 'dev4' ? 
                <div className="locator" >
                    <div className="form-pane">
                        <div className="form-wrap">
                            <div className="logo">
                                <div className={`logo-title`}>
                                    <div className="ds-logo"></div>
                                    <span className={`ds-logo-text ${logo}`}>{commonui.title}</span>
                                    <span className="ds-version"></span>
                                </div>
                                <div className="logo-desc">
                                    <p>
                                        {logo === 'master' ? commonui.messages.mdmDesc: commonui.messages.bizdataDesc}
                                    </p>
                                </div>
                            </div>
                            <div className="form-wrapper">
                                <LoginForm>
                                    <div>
                                        <div className="id_input_container">
                                            <div className="placeholding-input">
                                                <UserId
                                                    autoComplete="off"
                                                    defaultValue={
                                                        Cookie.get("MDM_USER_ID") ||
                                                        undefined
                                                    }
                                                />
                                            </div>
                                            <span className="input_icon"></span>
                                        </div>
                                        <div className="pswd_input_container">
                                            <div className="placeholding-input">
                                                <Password className="login_input" />
                                            </div>
                                            <span className="input_icon"></span>
                                        </div>
                                        <input type="hidden" name="locale" value={locale} />
                                        <RememberMe />
                                    </div>
                                    <div className="login-button-container">
                                        <button type="submit" className="submit ui-button ui-widget primary">
                                            {commonui.messages.login}
                                        </button>
                                    </div>
                                    <div className="login-error-message">
                                        <LoginErrorMessage
                                            style={{ textOverflow: "ellipsis" }}
                                        />
                                    </div>
                                </LoginForm>
                                <div className="ds-selectbox lang">
                                    <select
                                        id="locale"
                                        name="locale"
                                        onChange={this.onChangeLang} 
                                        value={locale}
                                    >
                                        <option value="ko">{commonui.messages.langKo}</option>
                                        <option value="en">{commonui.messages.langEn}</option>
                                    </select>
                                    <div className="bottom-message"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            :
            (<div className="old-form-pane">
                <div className="form-wrapper">
                    <div className={`${logo ? logo : "master"} credit`}></div>
                    <LoginForm>
                        <div>
                            <div className="id_input_container">
                                <div className="placeholding-input">
                                    <UserId
                                        autoComplete="off"
                                        defaultValue={
                                            Cookie.get("MDM_USER_ID") ||
                                            undefined
                                        }
                                    />
                                </div>
                                <span className="input_icon"></span>
                            </div>
                            <div className="pswd_input_container">
                                <div className="placeholding-input">
                                    <Password className="login_input" />
                                </div>
                                <span className="input_icon"></span>
                            </div>
                        </div>
                        <div className="login-button-container">
                            <div>
                                {/* 다국어 */}
                                <div className={"lang"}>
                                    <select 
                                        onChange={this.onChangeLang} 
                                        value={locale}
                                        style={{
                                            backgroundColor:'#262626',
                                            color:'white'
                                        }}
                                    >
                                        <option value="ko">Korean</option>
                                        <option value="en">English</option>
                                    </select>
                                </div>
                                <input
                                    type="checkbox"
                                    className="remember-me"
                                    id="save-id"
                                    name="MDM_ID_SAVED"
                                    defaultChecked={
                                        !!Cookie.get("MDM_ID_SAVED")
                                    }
                                />
                                <label
                                    className="remember-me"
                                    htmlFor="save-id"
                                >
                                    {commonui.messages.savedId}
                                </label>
                            </div>
                            <button type="submit" className="submit">
                                {commonui.messages.login}
                            </button>
                        </div>
                        <div className="login-error-message">
                            <LoginErrorMessage
                                style={{ textOverflow: "ellipsis" }}
                            />
                        </div>
                        
                    </LoginForm>
                    
                </div>
            </div>)
        );
    }
}

render(<MDMLoginForm />, document.getElementById("login"));
